// TEMPORARY: remove once NekoLens is released to the public.
// Only consumer is useShowNekoLens, which needs the MOOD site's
// visibility to gate NekoLens during the internal/restricted rollout.
import { skipToken, useQuery } from "@tanstack/react-query";
import { APIClient } from "lib/api/client";
import { useAPIClient } from "render/context/APIContext";
import { ExtractBody, ExtractKey, QueryOptions } from "typings/query";

const queryKey = (siteId: string | undefined) => ["site", siteId] as const;
const queryFn = (apiClient: APIClient, siteId: string) => async () => {
  return await apiClient.site.getSite(siteId).result;
};

type Body = ExtractBody<typeof queryFn>;
type Key = ExtractKey<typeof queryKey>;

export function useSiteQuery<T = Body>({
  siteId,
  options = {},
}: {
  siteId: string | undefined;
  options?: QueryOptions<Body, Key, T>;
}) {
  const apiClient = useAPIClient();

  return useQuery({
    queryKey: queryKey(siteId),
    queryFn: siteId ? queryFn(apiClient, siteId) : skipToken,
    staleTime: Infinity,
    ...options,
  });
}

useSiteQuery.queryKey = queryKey;
useSiteQuery.queryFn = queryFn;
